export const pathToLogoComplete = `${process.env.PUBLIC_URL}/assets/DS-logo-full-stacked.png`;
